// extracted by mini-css-extract-plugin
export default {"settings__wrapper":"styles_settings__wrapper__hAPR1","settings__label":"styles_settings__label__-k-Xp","settings__item":"styles_settings__item__g+TU3"};